module.exports = __webpack_public_path__ + "static/media/logoVisiconnect.2cb73ac9.svg";